/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Outreach_Emailsentsuccess3Inputs */

const en_coinvestments_outreach_emailsentsuccess3 = /** @type {(inputs: Coinvestments_Outreach_Emailsentsuccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email sent successfully`)
};

/**
* | output |
* | --- |
* | "Email sent successfully" |
*
* @param {Coinvestments_Outreach_Emailsentsuccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_outreach_emailsentsuccess3 = /** @type {((inputs?: Coinvestments_Outreach_Emailsentsuccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Outreach_Emailsentsuccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_outreach_emailsentsuccess3(inputs)
});
export { coinvestments_outreach_emailsentsuccess3 as "coInvestments_outreach_emailSentSuccess" }